export default __webpack_public_path__ + "static/media/gauge-black.4c4a22f3.svg";